import { slotAnzahl, spalten, type Form, type Operation } from "@gui-creator/gemeinsam";

/** Verschiebt die Auswahl um den Versatz zwischen gegriffenem Slot und Ziel; null, wenn etwas aus der Form fiele. */
export function verschiebeOps(auswahl: number[], von: number, ziel: number, form: Form, kopieren: boolean): Operation | null {
  const s = spalten(form);
  const n = slotAnzahl(form);
  const dr = Math.floor(ziel / s) - Math.floor(von / s);
  const dc = (ziel % s) - (von % s);
  if (dr === 0 && dc === 0) return null;
  const paare: { von: number; nach: number }[] = [];
  for (const i of [...auswahl].sort((a, b) => a - b)) {
    const r = Math.floor(i / s) + dr;
    const c = (i % s) + dc;
    const nach = r * s + c;
    if (c < 0 || c >= s || r < 0 || nach >= n) return null;
    paare.push({ von: i, nach });
  }
  return { art: "slots_verschieben", paare, kopieren };
}
